export const manualReports: Record<string, readonly [string, string, string, string]> = {};
